module.exports = __webpack_public_path__ + "img/grid-grey.9e005a7c.svg";